import { Injectable, EventEmitter, Pipe, PipeTransform } from '@angular/core';
import {ApiService} from '../shared/api.service';
import {UserService} from '../shared/user.service';
import {StatusMap} from './assignment.model';
import {ViewService} from '../shared/view.service';

@Pipe({name: 'matcher'})
export class MatcherPipe implements PipeTransform {
    transform(list, values): string {
        if( !list || !values ) return;
        return list.filter(item => {
            return values.indexOf(item.name) !== -1 ? true : false;
        });
    }
}
@Pipe({name: 'doNotFilter'})
export class DoNotFilterPipe implements PipeTransform {
    transform(list, values): string {
        if( !list || !values ) return;
        return list.filter(item => {
            return values.indexOf(item.column) === -1 ? true : false;
        });
    }
}
@Pipe({name: 'orderBy'})
export class OrderByPipe implements PipeTransform {
    transform(list, prop): string {
        if( !list || !prop ) return;
        return list.sort((a, b) => {
            let aValue = a[prop];
            let bValue = b[prop];
            if (aValue < bValue) {
                return -1;
            }
            if (aValue > bValue) {
                return 1;
            }
            return 0;
        });
    }
}
@Injectable()
export class FiltersService {
    columns = ['dueDate', 'title', 'id', 'status', 'childType', 'sites', 'team', 'lock', 'actions'];
    doNotFilter = ['lock', 'actions'];
    matchers = [
        {
            name: 'contains',
            template: 'textField',
            compare: 'LIKE'
        },
        {
            name: 'does not contain',
            template: 'textField',
            compare: 'NOT LIKE'
        },
        {
            name: 'is',
            template: 'check',
            compare: '='
        },
        {
            name: 'is empty ',
            compare: '=',
            template: 'string'
        },
        {
            name: 'is not empty ',
            compare: '!=',
            template: 'string'
        },
        {
            name: 'is empty',
            compare: '=',
            template: 'zero'
        },
        {
            name: 'is not empty',
            compare: '!=',
            template: 'zero'
        },
        {
            name: 'is type',
            compare: '=',
            template: 'type'
        },
        {
            name: 'is type ',
            compare: '=',
            template: 'quizType'
        },     
        {
            name: 'exact date',
            compare: 'LIKE',
            template: 'datePicker'
        },    
        {
            name: 'between',
            compare: 'BETWEEN',
            template: 'datePicker2'
        },    
        {
            name: 'before',
            compare: '<',
            template: 'datePicker'
        },
        {
            name: 'after',
            compare: '>',
            template: 'datePicker'
        }, 
        {
            name: 'has user',
            compare: 'IN',
            template: 'users'
        },
        {
            name: 'has user ',
            compare: 'LIKE',
            template: 'users'
        },
        {
            name: 'is site',
            compare: '=',
            template: 'site'
        },
        {
            name: 'has site',
            compare: 'LIKE',
            template: 'hasSite'
        },
        {
            name: 'is priority',
            compare: '=',
            template: 'priority'
        },
        {
            name: 'is status',
            compare: '=',
            template: 'status'
        },
        {
            name: 'has tag',
            compare: '',
            template: 'tag'
        },
        {
            name: 'has taxonomy',
            compare: 'LIKE',
            template: 'tax'
        },
        {
            name: 'has term',
            compare: 'LIKE',
            template: 'term'
        },
        {
            name: 'has affiliate',
            compare: 'LIKE',
            template: 'affiliates'
        },
        {
            name: 'is checked',
            compare: '=',
            template: 'checked'
        },
        {
            name: 'has creator',
            compare: 'LIKE',
            template: 'textField',
            valuePrefix: 'creation:'
        }
    ];
    fields = [
        {
            name: 'Due',
            column: 'dueDate',
            options: ['exact date', 'between', 'before', 'after', 'is empty '],
            visible: true
        },
        {
            name: 'Affiliates',
            column: 'affiliates',
            options: ['is checked', 'has affiliate'],
            visible: false
        },
        {
            name: 'Assignment Title',
            column: 'title',
            options: ['contains', 'does not contain', 'is empty ', 'is not empty '],
            visible: true
        },
        {
            name: 'Article Title',
            column: 'articleTitle',
            options: ['contains', 'does not contain', 'is empty ', 'is not empty '],
            visible: false
        },
        {
            name: 'Assignment ID',
            column: 'id',
            options: ['contains'],
            visible: true
        },
        {
            name: 'Status',
            column: 'status',
            options: ['is status'],
            visible: true
        },
        {
            name: 'Type',
            column: 'childType',
            options: ['is type'],
            visible: true
        },
        {
            name: 'Quiz Type',
            column: 'quizType',
            options: ['is type '],
            visible: true
        },
        {
            name: 'Properties',
            column: 'sites',
            options: ['has site'],
            visible: true
        },
        {
            name: 'Team',
            column: 'team',
            options: ['has user ', 'is empty '],
            visible: true
        },
        {
            name: 'Abbreviation',
            column: 'abbreviation',
            options: ['contains', 'does not contain', 'is empty ', 'is not empty '],
            visible: false
        },
        {
            name: 'Additions Due',
            column: 'pageAddDate',
            options: ['exact date', 'between', 'before', 'after'],
            visible: false
        },
        {
            name: 'Additions Writer',
            column: 'pageAddWriter',
            options: ['has user', 'is empty'],
            visible: false
        },
        {
            name: 'Date Published',
            column: 'publishDate',
            options: ['exact date', 'between', 'before', 'after'],
            visible: false
        },
        {
            name: 'Editor',
            column: 'editor',
            options: ['has user', 'is empty'],
            visible: false
        },
        {
            name: 'Priority',
            column: 'priority',
            options: ['is priority'],
            visible: false
        },
        {
            name: 'Taxonomy',
            column: 'taxonomies',
            options: ['has taxonomy'],
            visible: false
        },
        {
            name: 'Target Publish Date',
            column: 'targetPublishDate',
            options: ['exact date', 'between', 'before', 'after', 'is empty '],
            visible: false
        },
        {
            name: 'Writer',
            column: 'writer',
            options: ['has user', 'is empty'],
            visible: false
        },
        {
            name: 'Actions',
            column: 'actions',
            options: [],
            visible: true
        },
        {
            name: 'Category',
            column: 'siteCategorySearch',
            options: ['contains', 'does not contain', 'is empty ', 'is not empty '],
            visible: false
        },
        {
            name: 'Creator',
            column: 'taxonomySearch',
            options: ['has creator'],
            visible: false
        }
    ];
    filters = [];
    filtersChange = new EventEmitter();
    query = {
        filters: [],
        relation: 'And'
    };
    sites = [];
    statuses = [];
    users = [];
    views = [];

    constructor(private api: ApiService, private userService: UserService, private vs: ViewService) {
        this.loadSettings();
        this.loadStatuses();
        this.loadUsers();
        this.loadSites();
        //this.loadTaxonomies();
        this.vs.currentViewChange.subscribe(view => {
            if( view ) {
                this.columns = view.columns;
                this.maybeAddPreColumn();
                this.query.relation = view.relation;
                this.filters = view.filters;
                this.changeValues();
                this.updateFields();
            } else {
                this.reset();
            }
        });
    }
    addDateValue(filter, value, index) {
        if( !Array.isArray(filter.values) ) {
            filter.values = [];
        }
        filter.values[index] = value.toISOString().slice(0,10);
        if( filter.values.length == 2 ) {
            this.changeValues();
        }
    }
    addFilter() {
        let field = this.fields[0];
        let option = field.options[0];
        let matcher = this.matchers.filter(item => item.name == option);
        this.filters.push({
            field: field,
            matcher: matcher[0],
            values: ''
        });
        this.changeValues();
    }
    removeFilter(i) {
        this.filters.splice(i, 1);
        localStorage.setItem('userFilters', JSON.stringify(this.filters));
        this.changeValues();
    }
    changeFilter(i) {
        let filter = this.filters[i];
        let option = filter.field.options[0];
        filter.matcher = this.matchers.filter(item => item.name == option)[0];
        filter.values = '';
        if( filter.matcher.template == 'zero' ) {
            filter.value = '0';
        }
        if( filter.matcher.template == 'checked' ) {
            filter.values = '1';
        }
        this.changeValues();
    }
    changeMatcher(i) {
        let filter = this.filters[i];
        let value = '';
        if( filter.matcher.template == 'zero' ) {
            value = '0';
        }
        if( filter.matcher.template == 'checked' ) {
            value = '1';
        }
        filter.values = value;
        this.changeValues();
    }
    changeValues() {
        this.updateQueryArgs();
        this.filtersChange.emit(this.query);
        localStorage.setItem('userFilters', JSON.stringify(this.filters));
    }
    getQueryValue(value) {
        if( Array.isArray(value) ) {
            value = value.join('|');
        }
        if( value instanceof Date ) {
            value = value.toISOString().slice(0,10);
        }
        return value;
    }
    updateQueryArgs() {
        let filters = this.filters;
        let len = filters.length;
        let query = this.query;
        query.filters = [];
        for(var i = 0; i < len; i++) {
            let filter = filters[i];
            let value = this.getQueryValue(filter.values);
            let key = filter.field.search ? filter.field.search : filter.field.column;
            query.filters.push({
                key: key,
                value: value,
                compare: filter.matcher.compare,
                valuePrefix: filter.matcher.valuePrefix
            });
        }
    }
    loadSettings() {
        try {
            let userFilters = JSON.parse(localStorage.getItem('userFilters'));
            if( userFilters ) {
                this.filters = userFilters;
            }
        } catch(e) {
            console.log('Failed loading user settings.', e);
        }
    }
    loadStatuses() {
        let statuses = this.statuses;
        for(let value in StatusMap) {
            let name = StatusMap[value];
            statuses.push({
                name: name,
                value: value
            });
        }
        this.statuses = statuses;
    }
    loadUsers() {
        this.users = this.userService.getUsers();
    }
    loadSites() {
        let sites = this.api.getProp('sites');
        const user = this.api.getProp('user');
        if( user.limited.length > 0 ) {
            sites = sites.filter(site => user.limited.indexOf(site.blog_id) !== -1);
        }
        this.sites = sites;
    }
    loadTaxonomies() {
        const taxOptions = this.api.getProp('taxonomies');
        const taxSlugs = Object.keys(taxOptions);
        let items = [];
        for(var i = 0; i < taxSlugs.length; i++) {
            const slug = taxSlugs[i];
            const tax = taxOptions[slug];
            items.push({
                name: tax.name,
                column: tax.slug,
                search: 'taxonomies',
                options: ['has term'],
                visible: false
            });
        }
        const insertAt = this.fields.length - 3;
        this.fields.splice(insertAt, 0, ...items);
    }
    maybeAddPreColumn() {
        const user = this.api.getProp('user');
        if( user.role == 'editor' || user.role == 'administrator' ) {
            this.columns = ['pre'].concat(this.columns);
        }
    }
    reset() {
        this.columns = ['dueDate', 'title', 'id', 'status', 'childType', 'sites', 'team', 'lock', 'actions'];
        this.maybeAddPreColumn();
        this.query.relation = 'And';
        //this.resetFilters();
        this.changeValues();
        this.updateFields();
    }
    resetFilters() {
        this.filters = [];
        localStorage.setItem('userFilters', JSON.stringify(this.filters));
        this.changeValues();
    }
    updateColumns() {
        let columns = this.fields.filter(item => item.visible && item.column !== 'actions' && item.column !== 'lock').map(item => item.column);
        columns = columns.concat(['lock', 'actions']);
        this.columns = columns;
        this.maybeAddPreColumn();
    }
    updateFields() {
        let columns = this.columns;
        this.fields = this.fields.map(item => {
            if( columns.indexOf(item.column) !== -1 ) {
                item.visible = true;
            } else {
                item.visible = false;
            }
            return item;
        });
    }
}
